
import { dispatchElement, setValueOfXNode, valueOfXNode } from '../shared/domHelper'
import { asArray } from '../shared/functions'
import { compactCurrencyNumber, formatInKoreaPhoneNumber } from '../shared/user_methods'

export function main(Alpine) {

  Alpine.directive('fixed-value', (el, { expression }, { evaluate, effect })=>{
    el.addEventListener('fixedvalue:update', () => {
      const evaluatedValue = evaluate(expression)
      setValueOfXNode(el, evaluatedValue)
    })

    el.addEventListener('blur', () => {
      dispatchElement(el, 'fixedvalue:update')
    })

    effect(()=>{
      dispatchElement(el, 'fixedvalue:update')
    })
  })
  
  Alpine.directive('format-number', (el, { modifiers, expression }, { evaluate }) => {
    let snapValue = ''

    if(!modifiers.length){
      modifiers.push("compact")
    }

    el.addEventListener('focus', () => {
      snapValue = valueOfXNode(el)
    })

    el.addEventListener('blur', () => {
      try {
        let elValue = valueOfXNode(el)
        if(elValue.trim() === '') {
          setValueOfXNode(el, '')
          return
        }
        if (modifiers.includes('phone')) {
          // 포맷 불가 번호(지역번호 등)는 입력값을 지우지 않고 원본 유지 — 유효성 판정은 서버(TextEasy.korea_phone_number?) 책임 #164
          elValue = formatInKoreaPhoneNumber(elValue) || elValue
        }

        if (modifiers.includes('compact')) {
          elValue = elValue.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1')
        }

        if (modifiers.includes('currency')) {
          elValue = compactCurrencyNumber(elValue) || ""
        }
        
        setValueOfXNode(el, elValue)
      } catch(e) {
        setValueOfXNode(el, snapValue)
        console.error(e)
      }
    })
  })

  Alpine.directive('custom-validations', (el, { modifiers, expression }, { evaluateLater, effect }) => {
    // expression을 평가하여 validityTargets 배열을 가져옵니다.
    const contextedExpression = `(()=>{
      function required(_1) {
        function generateRequired(message="필수 입력 항목입니다") {
          return ({value}) => value === null ? message : String(value).trim() === '' ? message : ''
        }
        if(arguments.length === 0) return generateRequired()
        if(typeof _1 === "string") return generateRequired(_1)
        return generateRequired()(_1)
      }
      function minlength(length) {
        return ({ value }) => String(value).length < length ? ('최소 ' + length + '자 이상 입력해야 합니다') : ''
      }
      function maxlength(length) {
        return ({ value }) => String(value).length > length ? ('최대 ' + length + '자 이하로 입력해야 합니다') : ''
      }
      function min(min) {
        return ({ value }) => Number(value) < min ? '최소 ' + min + ' 이상 입력해야 합니다' : ''
      }
      function max(max) {
        return ({ value }) => Number(value) > max ? '최대 ' + max + ' 이하로 입력해야 합니다' : ''
      }
      function pattern(pattern) {
        return ({ value }) => !new RegExp(pattern).test(value) ? '올바른 형식이 아닙니다' : ''
      }
      function equals(values){
        return ({ value }) => {
          Array.from(values).some(v => v === value);
        }
      }
      return ${expression} 
    })()`
    const getCustomValidations = evaluateLater(contextedExpression)
    function validateSingle(validationFunction) {
      const value = valueOfXNode(el)
      const name = el.name
      const type = el.type
      
      const result = validationFunction({ value, name, type }, el)
      if (typeof result === 'string'){
        return result
      }
      if (result === true) {
        return ''
      }
      if (result === false) {
        return '올바른 입력이 아닙니다'
      }
      if (result === null) {
        return ''
      }
      console.warn("x-custom-validations 유효하지 않은 값", result, validationFunction)
      return String(result)
    }
    
    function validateAll(validations){
      let destCustomValidity = ''
      validations.some((validationFunction) => {
        const result = validateSingle(validationFunction)
        if(result.length){
          destCustomValidity = result
          return true
        }
      })
      return destCustomValidity
    }

    let customValidations = null

    el.addEventListener('customvalidation:update', () => {

      if(customValidations === null){
        return
      }

      const message = validateAll(customValidations)

      if(message){
        el.setCustomValidity(message)
        dispatchElement(el, 'customvalidation:updated')
      } else {
        el.setCustomValidity('')
        dispatchElement(el, 'customvalidation:updated')
      }
    })

    el.addEventListener('input', () => {
      dispatchElement(el, 'customvalidation:update')
    })

    el.addEventListener('blur', () => {
      dispatchElement(el, 'customvalidation:update')
    })

    el.addEventListener('touch', () => {
      dispatchElement(el, 'customvalidation:update')
    })

    effect(()=>{
      getCustomValidations((evaluatedValidations)=>{
        customValidations = asArray(evaluatedValidations).map((validationFunction)=>{
          if(typeof validationFunction === 'function'){
            return validationFunction
          } else {
            console.warn("x-custom-validations 유효하지 Validation callback", validationFunction)
            return null
          }
        }).filter(Boolean)
        
        dispatchElement(el, 'customvalidation:update')
      })
    })
  })

  // deprecated
  // Alpine.directive('push-ref', (el, { expression }, { evaluate, cleanup }) => {
  //   // expression을 평가하여 validityTargets 배열을 가져옵니다.
  //   const validityTargets = evaluate(expression);
    
  //   // validityTargets가 배열인지 확인합니다.
  //   if (!Array.isArray(validityTargets)) {
  //     console.warn('[alpine] x-validity-target: expression is not an array.', expression);
  //     return;
  //   }

  //   // 현재 엘리먼트를 validityTargets 배열에 추가합니다.
  //   validityTargets.push(el);

  //   // cleanup 함수를 사용하여 엘리먼트가 제거될 때 validityTargets 배열에서 제거합니다.
  //   cleanup(() => {
  //     const index = validityTargets.indexOf(el);
  //     if (index > -1) {
  //       validityTargets.splice(index, 1);
  //     }
  //   });
  // });

}
